import { useEffect, useState } from "react";
import ProjectDropDownBox from "./ProjectDropDownBox";
import axios from "axios";
import { Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import QuotationGrid from "./QuotationGrid";

export default function ReportByProject(props) {
  const { contrNo, setContrNo } = props;
  // const [contrNo, setContrNo] = useState(null);

  const [quot, setQuot] = useState([]);
  useEffect(async () => {
    console.debug("[useEffect of ReportByProject]");
    console.debug("contrNo", contrNo);

    if (contrNo) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/workR/report/quotations/${contrNo[0]}`
      );

      setQuot(result.data);

      console.debug("result.data", result.data);

      //   setQuotDataSource(
      //     new CustomStore({
      //       loadMode: "raw",
      //       key: "quotNo",
      //       load() {
      //         return result.data;
      //       },
      //     })
      //   );
    }
  }, [contrNo]);

  return (
    <>
      <div
        style={{
          width: "300px",
          // float: "left",
          marginRight: "10px",
          marginTop: "8px",
        }}
      >
        <div className="dx-fieldset">
          <div className="dx-field">
            <div className="dx-field-label">Project Name: </div>
            <div className="dx-field-value">
              <ProjectDropDownBox contrNo={contrNo} setContrNo={setContrNo} />
            </div>
          </div>
        </div>
      </div>
      <div className="dx-clearfix" />
      <div
        style={{
          height: "16px",
        }}
      />
      {quot.map(function (_quot) {
        return (
          <div key={_quot.quotNo}>
            <div style={{ margin: "16px 0px" }}>
              <QuotationGrid quot={_quot} />
              {/* <div>
                <Toolbar>
                  <Item location={"before"}>
                    <span
                      style={{
                        fontWeight: 500,
                        color: "#009688",
                        marginLeft: "10px",
                      }}
                    >
                      {_quot.quotNo}
                      {_quot.AOS ? ": " + _quot.AOS : ``}
                    </span>
                  </Item>
                </Toolbar>
                <QuotationGrid quot={_quot} />
                {/* <SalesGrid sales={sales} quot={_quot} />
                <ScrollToTopButtonComponent /> 
              </div> */}
            </div>
          </div>
        );
      })}
    </>
  );
}
